export default __webpack_public_path__ + "static/media/streaks 350.f16e964b.svg";